import { Inject, Injectable, Type } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import * as GoldenLayout from 'golden-layout';
import { IGoldenLayoutConfiguration, IComponentConfiguration, GoldenLayoutConfiguration } from './config';

/**
 * golden-layout component initialization callback type.
 */
export interface IComponentInitCallback extends Function {
  (container: GoldenLayout.Container, componentState: any): void;
}

export interface IComponentInitCallbackFactory {
  createComponentInitCallback(component: Type<any>): IComponentInitCallback;
}
export class GoldenLayoutService {
/**
 * @param {?} config
 */
constructor(
public readonly config: IGoldenLayoutConfiguration) {}
/**
 * @param {?} goldenLayout
 * @param {?} componentInitCallbackFactory
 * @return {?}
 */
public registerComponents(goldenLayout: GoldenLayout, componentInitCallbackFactory: IComponentInitCallbackFactory) {
    this.config.components.forEach((componentConfig: IComponentConfiguration) => {
      const /** @type {?} */ componentInitCallback = componentInitCallbackFactory.createComponentInitCallback(componentConfig.component);
      goldenLayout.registerComponent(componentConfig.componentName, componentInitCallback);
    });
  }
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: undefined, decorators: [{ type: Inject, args: [GoldenLayoutConfiguration, ] }, ]},
];
}

function GoldenLayoutService_tsickle_Closure_declarations() {
/** @type {?} */
GoldenLayoutService.decorators;
/**
 * @nocollapse
 * @type {?}
 */
GoldenLayoutService.ctorParameters;
/** @type {?} */
GoldenLayoutService.prototype.config;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
